export default __webpack_public_path__ + "ee35196e20c6d2b0439545495141ed38.png";